import adminApi from '@/api/admin';
import useAuth from '@/useAuth';
import { reactive, toRefs } from '@vue/composition-api'

const pageCategoriesState = reactive({
    pageCategories: [],
    isLoading: false,
    isLoaded: false
});

export default function usePageCategories() {


    const { user } = useAuth();

    const fetchPageCategories = async (forceRefresh = false) => {
        // Don't refetch if already loaded (unless forced)
        if (pageCategoriesState.isLoaded && !forceRefresh) {
            return;
        }

        if (user.value.is_tenant_admin === false) {
            pageCategoriesState.pageCategories = [];
            pageCategoriesState.isLoaded = true;
            return;
        }

        pageCategoriesState.isLoading = true;

        try {
            const response = await adminApi.getPageCategories();
            if (response.ok) {
                pageCategoriesState.pageCategories = response.data;
                pageCategoriesState.isLoaded = true;
            }
        } catch (error) {
            console.error('Failed to fetch page categories:', error);
        } finally {
            pageCategoriesState.isLoading = false;
        }
    }

    const refreshPageCategories = () => {
        return fetchPageCategories(true);
    }

    const clearPageCategories = () => {
        pageCategoriesState.pageCategories = [];
        pageCategoriesState.isLoaded = false;
    }

    return {
        ...toRefs(pageCategoriesState),
        fetchPageCategories,
        refreshPageCategories,
        clearPageCategories
    }
}
